module.exports = __webpack_public_path__ + "img/deep_work.c8e39ca9.png";